import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Navbar";
import { apiError } from "../lib/api";

const darkInput = "w-full rounded-lg border border-adminborder bg-adminbg px-3.5 py-2.5 text-sm text-slate-200 outline-none transition focus:border-saffron";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form.email, form.password, "admin");
      navigate("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-4 grain" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center"><Brand dark /></div>
        <div className="rounded-2xl border border-adminborder bg-admincard p-7 shadow-2xl">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-saffron/15 text-saffron"><ShieldCheck className="h-5 w-5" /></span>
            <div>
              <h1 className="font-heading text-xl font-bold text-white">Admin Console</h1>
              <p className="text-xs text-slate-500">Restricted to INDIAFAST staff</p>
            </div>
          </div>
          <form onSubmit={submit} className="mt-6 space-y-4">
            {error && <p data-testid="admin-login-error" className="rounded-lg bg-red-500/10 px-4 py-2.5 text-sm text-red-400">{error}</p>}
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
              <input type="email" required data-testid="admin-login-email-input" className={darkInput}
                     value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="staff@indiafast.in" />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
              <input type="password" required data-testid="admin-login-password-input" className={darkInput}
                     value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-saffron py-3 text-sm font-bold text-white transition-colors hover:bg-saffron-hover disabled:opacity-60">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in to Admin
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-slate-600">Customers &amp; partners sign in at indiafast.in/login</p>
      </div>
    </div>
  );
}
